import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { STRIPE_PUBLISHABLE_KEY } from '../../utils/stripeKeys';
import allActions from '../../state/actions';
import Layout from '../../components/layout/Layout';
import PreloaderBg from '../../components/shared/preloaderBg/PreloaderBg';
import CheckoutDetail from '../../components/cart/checkoutDetail/CheckoutDetail';

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

const Checkout = () => {
	const location = useLocation();
	const dispatch = useDispatch();
	const currentPage = useSelector((state) => state.currentPage);
	const staticPages = useSelector((state) => state.staticPages);
	const user = useSelector((state) => state.user);
	const order = useSelector((state) => state.order);
	const isFetching = currentPage.isFetching;

	// importo (in centesimi) per il Payment Element in deferred mode
	const stripeAmount = Math.round((order?.totalCart || 0) * 100);

	useEffect(() => {
		// Al ritorno da un redirect Stripe (Klarna/SEPA/Satispay) NON ricarico il dettaglio
		// checkout: la finalizzazione in CheckoutDetail ruota la sessione e poi ricarica la
		// pagina. Una fetch concorrente col token vecchio riscriverebbe il cookie di sessione
		// al valore vecchio, vanificando la rotazione del token.
		if (
			typeof window !== 'undefined' &&
			new URLSearchParams(window.location.search).get('payment_intent')
		) {
			return;
		}

		// controllo nello store se ho già il dettaglio della pagina di concludi ordine (checkout), altrimenti eseguo action creator
		const checkoutPage = staticPages.checkout;

		if (checkoutPage === undefined || checkoutPage.detail === undefined) {
			// non ho i dati del prodotto nello store, chiamo action creator fetchCheckoutDetail
			setTimeout(
				() =>
					dispatch(
						allActions.checkoutDetailActions.fetchCheckoutDetail(
							currentPage.currentLang,
							user.token_id,
							user.userData.id
						)
					),
				50
			);
		} else {
			// loading...
			dispatch(allActions.isFetchingAction.loadStoredData());

			// recupero dati da store
			dispatch(
				allActions.checkoutDetailActions.loadCheckoutDetail(checkoutPage)
			);
		}

		//console.log(checkoutPage);
	}, [location]);

	return (
		<Layout>
			<div className='container mx-auto'>
				<PreloaderBg showPreloader={isFetching} />
				<div className='grid grid-cols-60'>
					{stripeAmount > 0 ? (
						<Elements
							stripe={stripePromise}
							options={{
								mode: 'payment',
								amount: stripeAmount,
								currency: 'eur',
							}}
						>
							<CheckoutDetail />
						</Elements>
					) : null}
				</div>
			</div>
		</Layout>
	);
};

export default Checkout;
